//Core
import React from "react"

//Components
import Layout from "../../container/Layout"
import CashBack from "../../modules/cashback"
import Banner from "../../components/Banner"

//Styles
import "../../styles/main.scss"

const CashNowpage = () => (
  <Layout
    title={`АКЦІЯ: подвійний кешбек для вас! | ТАСКОМБАНК`}
    description={`Поспішайте отримайте подвійний кешбек за ваші покупки!`}
    link={`https://tascombank.ua/promo/cashback/`}
  >
    <Banner></Banner>
    <CashBack
      link={`https://tascombank.ua/files/Ofitsiini_pravyla_aktsii_Podviinyi.pdf`}
    ></CashBack>
  </Layout>
)

export default CashNowpage
